
module.exports = {
	status: 'ready',
	title: 'Slider',
	notes: '',
	context: {
		title: 'slider-items',
		items: [
			{title:'Sommaren 2010 beslutade regeringen att ett helt nytt helikoptersystem skulle anskaffas.', caption: 'orem ipsum dolor sit amet, consectetur adipiscing elit. Mauris faucibus quis dui nec cursus. Vestibulum dapibus metus maximus tellus rutrum accumsan sodales eget elit. Nunc in leo vel purus viverra lacinia.', image: '/images/demo-image-1.jpg'},
			{title:'Vi upphandlar tvätt och reparation av soldatmateriel samt sömnad.', caption: 'orem ipsum dolor sit amet, consectetur adipiscing elit. Mauris faucibus quis dui nec cursus. Vestibulum dapibus metus maximus tellus rutrum accumsan sodales eget elit. Nunc in leo vel purus viverra lacinia.', image:'/images/demo-soldat-2.jpg'},
			{title:'Sommaren 2010 beslutade regeringen att ett helt nytt helikoptersystem skulle anskaffas.', caption: 'orem ipsum dolor sit amet, consectetur adipiscing elit. Mauris faucibus quis dui nec cursus.', image: '', video:'/video/demo-video-1.mp4'},
		],
	},
};
